<script setup>
/**
 * @fileoverview ShareInvalidPage - Error page for invalid share URLs
 *
 * Shown when user visits /share or /share/ without a valid share ID.
 */

import { AlertCircle } from 'lucide-vue-next'
import Card from '@/components/ui/card/Card.vue'
import CardContent from '@/components/ui/card/CardContent.vue'
import CardHeader from '@/components/ui/card/CardHeader.vue'
import CardTitle from '@/components/ui/card/CardTitle.vue'
</script>

<template>
  <div
    class="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex flex-col items-center justify-center px-4 py-12"
  >
    <!-- Header with Branding -->
    <div class="mb-8 text-center">
      <h1 class="text-4xl font-bold text-indigo-600 dark:text-indigo-400 mb-2">Autolabs</h1>
      <p class="text-sm text-gray-600 dark:text-gray-400">Virtual Lab Platform</p>
    </div>

    <!-- Error Card -->
    <Card class="w-full max-w-md">
      <CardHeader>
        <CardTitle class="flex items-center gap-2 text-red-600 dark:text-red-400">
          <AlertCircle class="w-5 h-5" />
          Invalid Share Link
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p class="text-gray-600 dark:text-gray-400 mb-4">
          This URL is not valid. You need a complete share link to access a shared lab.
        </p>
        <p class="text-sm text-gray-500 dark:text-gray-500">
          Please contact the person who shared the lab with you to get a valid share link.
        </p>
      </CardContent>
    </Card>
  </div>
</template>
